﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
import { AppLog } from "../AppLog";
    export class GuiListClearoSuche extends GuiListGeneric {

        constructor() {
            super("ClearoSuche");
        }

        protected attachEvents() {
             $("div.erz-list-element-goto").on("click", (e) => { this.clickRowGoto(e); });
        }


        clickRowGoto(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
            AppLog.logInfo("clickRowGoto");
            e.preventDefault();

            const id = $(e.currentTarget).closest("div.erz-list-element").data("id");
            const baseUrl = $("div.erz-list").data("load-url");
            const url = `${baseUrl}/${id}`;
            this.gotoUrl(url);
        }
    }
